'use client';

import config from 'config';

import { useBreakpointValue, VStack } from '@chakra-ui/react';

import { useAppSelector } from 'store/hooks';
import { userSelector } from 'store/reducers/userSlice';

import { PromoBanner } from 'components/PromoBanner';
import { GiftCardBlock, SavingsBlock } from './components';

const {
  dashboard: { sidebar }
} = config;

const SecondarySidebar = () => {
  const { user } = useAppSelector(userSelector);
  const isShowPromoBanner = useBreakpointValue({ base: false, lg: true });

  return (
    <VStack
      gap={0}
      width='100%'
      maxWidth={{ base: '100%', lg: '280px', xl: '304px' }}
      pl={0}
    >
      {user?.membership_bank_balance && (
        <SavingsBlock
          title='Membership Bank'
          amount={user?.membership_bank_balance}
        />
      )}

      <GiftCardBlock
        title={
          user?.gift_cards_balance
            ? sidebar.availableGiftCardsText
            : sidebar.noGiftCardsText
        }
        amount={user?.gift_cards_balance || 'Buy Gift Card'}
        image={sidebar.giftCard}
        isAlternativeVariant={!!user?.membership_bank_balance}
      />

      {isShowPromoBanner && <PromoBanner />}
    </VStack>
  );
};

export default SecondarySidebar;
